// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as View from "../../primitives/View.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as CountBadge from "../../resources/feedback-indicators/CountBadge.res.js";
import * as DeviceName from "../../modules/Device/DeviceName.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as StaffSelect from "../../modules/Staff/StaffSelect.res.js";
import * as DeviceSelect from "../../modules/Device/DeviceSelect.res.js";
import * as ResourceList from "../../core/ResourceList.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StringHelpers from "../../helpers/StringHelpers.res.js";
import * as Client from "@apollo/client";
import * as LabelTableCell from "../../modules/TableCell/LabelTableCell.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as CategoryTablist from "../../resources/navigation/CategoryTablist.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as ResourceListPage from "../../core/ResourceListPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CashRegisterReport from "../../modules/CashRegisterReport/CashRegisterReport.res.js";
import * as CashRegisterReportPdf from "../../modules/CashRegisterReport/CashRegisterReportPdf.res.js";
import * as RequestOpenStorageUrl from "../../core/RequestOpenStorageUrl.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as SelectNumberRangeFilter from "../../resources/selection-and-input/SelectNumberRangeFilter.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
let make = React.memo(props => {
  let notification = props.notification;
  if (notification !== undefined) {
    return JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Banner.make, {
        textStatus: notification,
        onRequestClose: props.onRequestClose
      }),
      spaceX: "large",
      spaceTop: "medium"
    });
  } else {
    return null;
  }
});
let CashRegisterReportsListNotificationBanner = {
  make: make
};
function endpoint(exportKind, cashRegisterReportId, timeZone) {
  let tmp;
  tmp = exportKind === "Report" ? "/cash-register-reports/export/" : "/cash-register-reports/daily-grouped-per-month-export/";
  return Env.sheetUrl() + tmp + encodeURIComponent(cashRegisterReportId) + "?timeZone=" + encodeURIComponent(timeZone);
}
function make$1(exportKind, cashRegisterReportId) {
  return Request.make(endpoint(exportKind, cashRegisterReportId, I18n.timeZone), "GET", undefined, undefined, undefined);
}
let pendingMessage = I18n.t("cash_register_reports_list_page.export_request.pending");
let successMessage = I18n.t("The file has been downloaded successfully.");
let errorMessage = I18n.t("cash_register_reports_list_page.export_request.unexpected_failure");
let CashRegisterReportsListExportRequest = {
  endpoint: endpoint,
  make: make$1,
  pendingMessage: pendingMessage,
  successMessage: successMessage,
  errorMessage: errorMessage
};
let Raw = {};
let query = Client.gql(["query CashRegisterReportsListQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputCashRegisterReportsQueryFilter, $orderBy: [InputCashRegisterReportsQueryOrderBy!])  {\ncashRegisterReports(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy, orderBy: $orderBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nkind  \nopenedAt  \nopenedByStaffName  \nopenedByStaff  {\n__typename  \nname  \n}\n\nclosedAt  \nclosedByStaffName  \nclosedByStaff  {\n__typename  \nname  \n}\n\narchivedAt  \nshopName  \nshop  {\n__typename  \nname  \n}\n\ndeviceName  \ndevice  {\n__typename  \nname  \nslug  \n}\n\ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \nsalesReceiptNameRange  \n}\n\n}\n\n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.cashRegisterReports;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    cashRegisterReports: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.kind;
        let tmp;
        switch (value$2) {
          case "daily":
            tmp = "daily";
            break;
          case "monthly":
            tmp = "monthly";
            break;
          case "yearly":
            tmp = "yearly";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$3 = value$1.openedByStaffName;
        let value$4 = value$1.openedByStaff;
        let value$5 = value$1.closedAt;
        let value$6 = value$1.closedByStaffName;
        let value$7 = value$1.closedByStaff;
        let value$8 = value$1.archivedAt;
        let value$9 = value$1.shopName;
        let value$10 = value$1.shop;
        let value$11 = value$1.deviceName;
        let value$12 = value$1.device;
        let value$13 = value$1.salesReceiptNameRange;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            kind: tmp,
            openedAt: Scalar.Datetime.parse(value$1.openedAt),
            openedByStaffName: !(value$3 == null) ? value$3 : undefined,
            openedByStaff: {
              __typename: value$4.__typename,
              name: value$4.name
            },
            closedAt: !(value$5 == null) ? Scalar.Datetime.parse(value$5) : undefined,
            closedByStaffName: !(value$6 == null) ? value$6 : undefined,
            closedByStaff: !(value$7 == null) ? {
              __typename: value$7.__typename,
              name: value$7.name
            } : undefined,
            archivedAt: !(value$8 == null) ? Scalar.Datetime.parse(value$8) : undefined,
            shopName: !(value$9 == null) ? value$9 : undefined,
            shop: {
              __typename: value$10.__typename,
              name: value$10.name
            },
            deviceName: !(value$11 == null) ? value$11 : undefined,
            device: {
              __typename: value$12.__typename,
              name: value$12.name,
              slug: value$12.slug
            },
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            salesReceiptNameRange: value$13.map(value => value)
          }
        };
      })
    }
  };
}
function serialize(value) {
  let value$1 = value.cashRegisterReports;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.salesReceiptNameRange;
    let salesReceiptNameRange = value$2.map(value => value);
    let value$3 = value$1.totalAmountExcludingTaxes;
    let value$4 = value$1.totalAmountIncludingTaxes;
    let value$5 = value$1.device;
    let value$6 = value$5.slug;
    let value$7 = value$5.name;
    let value$8 = value$5.__typename;
    let device = {
      __typename: value$8,
      name: value$7,
      slug: value$6
    };
    let value$9 = value$1.deviceName;
    let deviceName = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.shop;
    let value$11 = value$10.name;
    let value$12 = value$10.__typename;
    let shop = {
      __typename: value$12,
      name: value$11
    };
    let value$13 = value$1.shopName;
    let shopName = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.archivedAt;
    let archivedAt = value$14 !== undefined ? Scalar.Datetime.serialize(value$14) : null;
    let value$15 = value$1.closedByStaff;
    let closedByStaff;
    if (value$15 !== undefined) {
      let value$16 = value$15.name;
      let value$17 = value$15.__typename;
      closedByStaff = {
        __typename: value$17,
        name: value$16
      };
    } else {
      closedByStaff = null;
    }
    let value$18 = value$1.closedByStaffName;
    let closedByStaffName = value$18 !== undefined ? value$18 : null;
    let value$19 = value$1.closedAt;
    let closedAt = value$19 !== undefined ? Scalar.Datetime.serialize(value$19) : null;
    let value$20 = value$1.openedByStaff;
    let value$21 = value$20.name;
    let value$22 = value$20.__typename;
    let openedByStaff = {
      __typename: value$22,
      name: value$21
    };
    let value$23 = value$1.openedByStaffName;
    let openedByStaffName = value$23 !== undefined ? value$23 : null;
    let value$24 = value$1.openedAt;
    let value$25 = Scalar.Datetime.serialize(value$24);
    let value$26 = value$1.kind;
    let kind = value$26 === "daily" ? "daily" : value$26 === "monthly" ? "monthly" : "yearly";
    let value$27 = value$1.name;
    let value$28 = value$1.id;
    let value$29 = value$1.__typename;
    let node = {
      __typename: value$29,
      id: value$28,
      name: value$27,
      kind: kind,
      openedAt: value$25,
      openedByStaffName: openedByStaffName,
      openedByStaff: openedByStaff,
      closedAt: closedAt,
      closedByStaffName: closedByStaffName,
      closedByStaff: closedByStaff,
      archivedAt: archivedAt,
      shopName: shopName,
      shop: shop,
      deviceName: deviceName,
      device: device,
      totalAmountIncludingTaxes: value$4,
      totalAmountExcludingTaxes: value$3,
      salesReceiptNameRange: salesReceiptNameRange
    };
    let value$30 = value.__typename;
    return {
      __typename: value$30,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let cashRegisterReports = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    cashRegisterReports: cashRegisterReports
  };
}
function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectInputCashRegisterReportsQueryOrderBy(inp) {
  let a = inp.openedAt;
  let a$1 = inp.closedAt;
  let a$2 = inp.turnover;
  let a$3 = inp.totalAmountIncludingTaxes;
  return {
    openedAt: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    closedAt: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    turnover: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined,
    totalAmountIncludingTaxes: a$3 !== undefined ? a$3 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeInputObjectInputCashRegisterReportsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.openedAt;
  let a$2 = inp.closedAt;
  let a$3 = inp.archivedAt;
  let a$4 = inp.kind;
  let a$5 = inp.deviceIds;
  let a$6 = inp.openedByStaffIds;
  let a$7 = inp.closedByStaffIds;
  let a$8 = inp.status;
  let a$9 = inp.totalAmountIncludingTaxes;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    openedAt: a$1 !== undefined ? serializeInputObjectDateFilter(a$1) : undefined,
    closedAt: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    archivedAt: a$3 !== undefined ? serializeInputObjectDateFilter(a$3) : undefined,
    kind: a$4 !== undefined ? serializeInputObjectInFilter(a$4) : undefined,
    deviceIds: a$5 !== undefined ? serializeInputObjectInFilter(a$5) : undefined,
    openedByStaffIds: a$6 !== undefined ? serializeInputObjectInFilter(a$6) : undefined,
    closedByStaffIds: a$7 !== undefined ? serializeInputObjectInFilter(a$7) : undefined,
    status: a$8 !== undefined ? serializeInputObjectInFilter(a$8) : undefined,
    totalAmountIncludingTaxes: a$9 !== undefined ? serializeInputObjectNumberRangeFilter(a$9) : undefined
  };
}
function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  let a$6 = inp.orderBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputCashRegisterReportsQueryFilter(a$5) : undefined,
    orderBy: a$6 !== undefined ? a$6.map(serializeInputObjectInputCashRegisterReportsQueryOrderBy) : undefined
  };
}
function makeVariables(search, before, after, first, last, filterBy, orderBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy,
    orderBy: orderBy
  };
}
function makeInputObjectInputCashRegisterReportsQueryFilter(shopIds, openedAt, closedAt, archivedAt, kind, deviceIds, openedByStaffIds, closedByStaffIds, status, totalAmountIncludingTaxes, param) {
  return {
    shopIds: shopIds,
    openedAt: openedAt,
    closedAt: closedAt,
    archivedAt: archivedAt,
    kind: kind,
    deviceIds: deviceIds,
    openedByStaffIds: openedByStaffIds,
    closedByStaffIds: closedByStaffIds,
    status: status,
    totalAmountIncludingTaxes: totalAmountIncludingTaxes
  };
}
function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}
function makeInputObjectInputCashRegisterReportsQueryOrderBy(openedAt, closedAt, turnover, totalAmountIncludingTaxes, param) {
  return {
    openedAt: openedAt,
    closedAt: closedAt,
    turnover: turnover,
    totalAmountIncludingTaxes: totalAmountIncludingTaxes
  };
}
function makeDefaultVariables() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined,
    orderBy: undefined
  };
}
let CashRegisterReportsListQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCashRegisterReportsQueryFilter: serializeInputObjectInputCashRegisterReportsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  serializeInputObjectInputCashRegisterReportsQueryOrderBy: serializeInputObjectInputCashRegisterReportsQueryOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputCashRegisterReportsQueryFilter: makeInputObjectInputCashRegisterReportsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeInputObjectInputCashRegisterReportsQueryOrderBy: makeInputObjectInputCashRegisterReportsQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});
let use = include.use;
let CashRegisterReportsListQuery_refetchQueryDescription = include.refetchQueryDescription;
let CashRegisterReportsListQuery_useLazy = include.useLazy;
let CashRegisterReportsListQuery_useLazyWithVariables = include.useLazyWithVariables;
let CashRegisterReportsListQuery = {
  CashRegisterReportsListQuery_inner: CashRegisterReportsListQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCashRegisterReportsQueryFilter: serializeInputObjectInputCashRegisterReportsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  serializeInputObjectInputCashRegisterReportsQueryOrderBy: serializeInputObjectInputCashRegisterReportsQueryOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputCashRegisterReportsQueryFilter: makeInputObjectInputCashRegisterReportsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeInputObjectInputCashRegisterReportsQueryOrderBy: makeInputObjectInputCashRegisterReportsQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: CashRegisterReportsListQuery_refetchQueryDescription,
  use: use,
  useLazy: CashRegisterReportsListQuery_useLazy,
  useLazyWithVariables: CashRegisterReportsListQuery_useLazyWithVariables
};
function keyExtractor(param) {
  return param.id;
}
let CashRegisterReportsListTableRow = {
  keyExtractor: keyExtractor
};
function tableRowsFromQueryResult(queryResult) {
  return queryResult.cashRegisterReports.edges.map(param => {
    let node = param.node;
    return {
      id: node.id,
      name: node.name,
      shopName: Stdlib_Option.getOr(node.shopName, node.shop.name),
      deviceLabel: DeviceName.format(DeviceName.decode(node.device.slug, Stdlib_Option.getOr(node.deviceName, node.device.name))),
      openedAt: node.openedAt,
      openedByStaffName: Stdlib_Option.getOr(node.openedByStaffName, node.openedByStaff.name),
      closedAt: node.closedAt,
      closedByStaffName: Stdlib_Option.orElse(node.closedByStaffName, Stdlib_Option.map(node.closedByStaff, staff => staff.name)),
      totalAmountIncludingTaxes: node.totalAmountIncludingTaxes,
      totalAmountExcludingTaxes: node.totalAmountExcludingTaxes,
      salesReceiptNameRange: CashRegisterReport.salesReceiptNameRangeLabel(node.salesReceiptNameRange),
      kind: CashRegisterReport.Kind.fromRaw(node.kind),
      status: CashRegisterReport.Status.fromDates(node.closedAt, node.archivedAt)
    };
  });
}
function encodeValues(values) {
  if (values.length !== 0) {
    return values;
  }
}
let dateRangeCodec = JsonCodec.object2(param => [param[0].getTime(), param[1].getTime()], param => ({
  TAG: "Ok",
  _0: [new Date(param[0]), new Date(param[1])]
}), JsonCodec.field("start", JsonCodec.float), JsonCodec.field("end", JsonCodec.float));
let amountCodec = JsonCodec.object2(param => [param.min, param.max], param => ({
  TAG: "Ok",
  _0: {
    min: param[0],
    max: param[1]
  }
}), JsonCodec.optional(JsonCodec.field("min", JsonCodec.float)), JsonCodec.optional(JsonCodec.field("max", JsonCodec.float)));
let staffCodec = JsonCodec.object2(param => [param.id, param.label], param => ({
  TAG: "Ok",
  _0: {
    id: param[0],
    label: param[1]
  }
}), JsonCodec.field("id", JsonCodec.string), JsonCodec.field("label", JsonCodec.string));
let deviceCodec = JsonCodec.object2(param => [param.id, param.label], param => ({
  TAG: "Ok",
  _0: {
    id: param[0],
    label: param[1]
  }
}), JsonCodec.field("id", JsonCodec.string), JsonCodec.field("label", JsonCodec.string));
function jsonCodec(shops) {
  return JsonCodec.object8(param => [Stdlib_Option.map(param.shop, shop => shop.id), Stdlib_Option.map(param.kind, CashRegisterReport.Kind.toString), param.openedAt, param.closedAt, encodeValues(param.statuses.map(CashRegisterReport.Status.toString)), param.amount, encodeValues(param.openedByStaffs), encodeValues(param.devices)], param => {
    let shopId = param[0];
    return {
      TAG: "Ok",
      _0: {
        shop: shops.find(shop => shop.id === shopId),
        kind: Stdlib_Option.flatMap(param[1], CashRegisterReport.Kind.fromString),
        openedAt: param[2],
        closedAt: param[3],
        statuses: Stdlib_Array.filterMap(Stdlib_Option.getOr(param[4], []), CashRegisterReport.Status.fromString),
        amount: param[5],
        openedByStaffs: Stdlib_Option.getOr(param[6], []),
        devices: Stdlib_Option.getOr(param[7], [])
      }
    };
  }, JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("kind", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("openedAt", dateRangeCodec)), JsonCodec.optional(JsonCodec.field("closedAt", dateRangeCodec)), JsonCodec.optional(JsonCodec.field("statuses", JsonCodec.array(JsonCodec.string))), JsonCodec.optional(JsonCodec.field("amount", amountCodec)), JsonCodec.optional(JsonCodec.field("openedByStaffs", JsonCodec.array(staffCodec))), JsonCodec.optional(JsonCodec.field("devices", JsonCodec.array(deviceCodec))));
}
function availableStatuses(kind) {
  if (kind === undefined) {
    return CashRegisterReport.Status.values;
  }
  switch (kind) {
    case "Daily":
      return CashRegisterReport.Status.values;
    case "Monthly":
      return ["Closed", "Archived"];
    case "Yearly":
      return ["Closed"];
  }
}
function defaultStatuses(kind) {
  if (kind === undefined) {
    return [];
  }
  switch (kind) {
    case "Daily":
      return ["Open", "Closed"];
    case "Monthly":
    case "Yearly":
      return ["Closed"];
  }
}
function isDefaultStatuses(statuses, kind) {
  let defaults = defaultStatuses(kind);
  if (statuses.length === defaults.length) {
    return statuses.every(status => defaults.includes(status));
  } else {
    return false;
  }
}
function activeCount(param) {
  return [Stdlib_Option.isSome(param.openedAt), Stdlib_Option.isSome(param.closedAt), !isDefaultStatuses(param.statuses, param.kind), Stdlib_Option.isSome(param.amount), param.openedByStaffs.length !== 0, param.devices.length !== 0].filter(active => active).length;
}
let CashRegisterReportsListFilters = {
  encodeValues: encodeValues,
  dateRangeCodec: dateRangeCodec,
  amountCodec: amountCodec,
  staffCodec: staffCodec,
  deviceCodec: deviceCodec,
  jsonCodec: jsonCodec,
  availableStatuses: availableStatuses,
  defaultStatuses: defaultStatuses,
  isDefaultStatuses: isDefaultStatuses,
  activeCount: activeCount
};
let make$2 = React.memo(props => {
  let onChange = props.onChange;
  let value = props.value;
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined,
    exclusive: defaultItem_4
  };
  let items = props.options.map(value => ({
    TAG: "Option",
    key: CashRegisterReport.Status.toString(value),
    label: CashRegisterReport.Status.toLabel(value),
    value: value
  }));
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Status"),
    preset: "filter",
    size: "compact",
    highlighted: value.length !== 0,
    renderValue: param => {
      let selectedItems = param.selectedItems;
      let exit = 0;
      let len = selectedItems.length;
      if (len !== 1) {
        exit = len !== 0 ? 1 : 2;
      } else {
        let match = selectedItems[0];
        if (match.TAG === "Option") {
          let status = match.value;
          if (status !== undefined) {
            return JsxRuntime.jsx(Inline.make, {
              children: JsxRuntime.jsx(CashRegisterReport.Status.Badge.make, {
                value: status,
                size: "M"
              })
            });
          }
          exit = 2;
        } else {
          exit = 1;
        }
      }
      switch (exit) {
        case 1:
          return JsxRuntime.jsx(CountBadge.make, {
            children: selectedItems.length.toString(),
            size: "small",
            tone: "brand"
          });
        case 2:
          return JsxRuntime.jsx("span", {
            children: I18n.t("All")
          });
      }
    },
    renderItem: param => {
      let item = param.item;
      if (item.TAG !== "Option") {
        return null;
      }
      let status = item.value;
      if (status !== undefined) {
        return JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(CashRegisterReport.Status.Badge.make, {
            value: status
          })
        });
      } else {
        return JsxRuntime.jsx("span", {
          children: I18n.t("All")
        });
      }
    },
    sections: [{
      items: [defaultItem]
    }, {
      items: items,
      title: I18n.t("Statuses")
    }],
    value: {
      TAG: "Multiple",
      _0: value.length !== 0 ? value.map(status => status) : [undefined]
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return;
      } else {
        return onChange(Stdlib_Array.filterMap(change._0, value => value));
      }
    }
  });
});
let CashRegisterReportsListStatusSelect = {
  make: make$2
};
let allKey = "all";
function items() {
  return [{
    key: allKey,
    label: I18n.t("All")
  }].concat(CashRegisterReport.Kind.values.map(kind => ({
    key: CashRegisterReport.Kind.toString(kind),
    label: CashRegisterReport.Kind.toLabel(true, kind)
  })));
}
function toKey(kind) {
  return Stdlib_Option.mapOr(kind, allKey, CashRegisterReport.Kind.toString);
}
function fromKey(key) {
  return CashRegisterReport.Kind.fromString(key);
}
let CashRegisterReportsListKindTabs = {
  allKey: allKey,
  items: items,
  toKey: toKey,
  fromKey: fromKey
};
function useExcelDownload(exportKind, cashRegisterReportId, onRequestNotification) {
  let match = RequestOpenStorageUrl.use(() => make$1(exportKind, cashRegisterReportId), undefined, undefined);
  let downloadResult = match[0];
  React.useEffect(() => {
    if (typeof downloadResult !== "object") {
      if (downloadResult !== "NotAsked") {
        onRequestNotification({
          TAG: "Info",
          _0: pendingMessage
        });
      }
    } else if (downloadResult.TAG !== "Reloading") {
      if (downloadResult._0.TAG === "Ok") {
        onRequestNotification({
          TAG: "Success",
          _0: successMessage
        });
      } else {
        onRequestNotification({
          TAG: "Danger",
          _0: errorMessage
        });
      }
    }
  }, [downloadResult]);
  return match[1];
}
let make$3 = React.memo(props => {
  let onRequestNotification = props.onRequestNotification;
  let name = props.name;
  let id = props.id;
  let downloadPdf = () => {
    Future.tapError(CashRegisterReportPdf.requestAndOpen(id, CashRegisterReport.nameLabel(name)), param => onRequestNotification({
      TAG: "Danger",
      _0: CashRegisterReportPdf.errorMessage
    }));
  };
  let downloadExcel = useExcelDownload("Report", id, onRequestNotification);
  let downloadMonthDetailExcel = useExcelDownload("MonthDetail", id, onRequestNotification);
  let tmp;
  let exit = 0;
  switch (props.kind) {
    case "Monthly":
      tmp = JsxRuntime.jsxs(MenuActions.Submenu.make, {
        children: [JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Monthly summary"),
          onAction: downloadExcel
        }), JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Daily detail"),
          onAction: downloadMonthDetailExcel
        })],
        title: I18n.t("Download Excel"),
        icon: "excel_see"
      });
      break;
    case "Daily":
    case "Yearly":
      exit = 1;
      break;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(MenuActions.Item.make, {
      title: I18n.t("Download Excel"),
      icon: "excel_see",
      onAction: downloadExcel
    });
  }
  return JsxRuntime.jsx(Offset.make, {
    children: JsxRuntime.jsx(MenuActions.make, {
      children: JsxRuntime.jsxs(MenuActions.Section.make, {
        children: [JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Download PDF"),
          icon: "pdf_see",
          onAction: downloadPdf
        }), tmp]
      }),
      trigger: {
        TAG: "Compact",
        icon: "more_v2",
        variant: "subtle",
        size: "small",
        bold: true
      }
    }),
    right: -13,
    width: 48,
    height: 32
  });
});
let CashRegisterReportsListTableRowActions = {
  useExcelDownload: useExcelDownload,
  make: make$3
};
function toSortDescriptor(sort) {
  switch (sort.TAG) {
    case "OpenedAt":
      return {
        column: "opened-at",
        direction: sort._0
      };
    case "ClosedAt":
      return {
        column: "closed-at",
        direction: sort._0
      };
    case "TotalAmount":
      return {
        column: "total-amount",
        direction: sort._0
      };
  }
}
function fromSortDescriptor(sort) {
  switch (sort.column) {
    case "closed-at":
      return {
        TAG: "Ok",
        _0: {
          TAG: "ClosedAt",
          _0: sort.direction
        }
      };
    case "opened-at":
      return {
        TAG: "Ok",
        _0: {
          TAG: "OpenedAt",
          _0: sort.direction
        }
      };
    case "total-amount":
      return {
        TAG: "Ok",
        _0: {
          TAG: "TotalAmount",
          _0: sort.direction
        }
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}
let jsonCodec$1 = JsonCodec.object2(sort => [toSortDescriptor(sort).column, toSortDescriptor(sort).direction], param => {
  let direction = param[1] === "descending" ? "descending" : "ascending";
  let ok = fromSortDescriptor({
    column: param[0],
    direction: direction
  });
  if (ok.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: ok._0
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: "Invalid sort descriptor"
      }
    };
  }
}, JsonCodec.field("column", JsonCodec.string), JsonCodec.field("direction", JsonCodec.string));
let CashRegisterReportsListSorting = {
  toSortDescriptor: toSortDescriptor,
  fromSortDescriptor: fromSortDescriptor,
  jsonCodec: jsonCodec$1
};
function queryVariablesDateFilter(dateRange) {
  if (dateRange !== undefined) {
    return {
      _after: undefined,
      _before: undefined,
      _between: [Scalar.Datetime.serialize(dateRange[0]), Scalar.Datetime.serialize(dateRange[1])]
    };
  }
}
function queryVariablesInFilter(ids) {
  if (ids.length !== 0) {
    return {
      _in: ids
    };
  }
}
function queryVariablesFilterBy(param) {
  let amount = param.amount;
  let kind = param.kind;
  let shop = param.shop;
  return {
    shopIds: shop !== undefined ? {
      _in: [shop.id]
    } : undefined,
    openedAt: queryVariablesDateFilter(param.openedAt),
    closedAt: queryVariablesDateFilter(param.closedAt),
    archivedAt: undefined,
    kind: kind !== undefined ? {
      _in: [CashRegisterReport.Kind.toString(kind)]
    } : undefined,
    deviceIds: queryVariablesInFilter(param.devices.map(device => device.id)),
    openedByStaffIds: queryVariablesInFilter(param.openedByStaffs.map(staff => staff.id)),
    closedByStaffIds: undefined,
    status: queryVariablesInFilter(param.statuses.map(CashRegisterReport.Status.toString)),
    totalAmountIncludingTaxes: amount !== undefined ? {
      _min: amount.min,
      _max: amount.max,
      _between: undefined
    } : undefined
  };
}
function queryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "OpenedAt":
      return {
        openedAt: toRawDirection(sort._0),
        closedAt: undefined,
        turnover: undefined,
        totalAmountIncludingTaxes: undefined
      };
    case "ClosedAt":
      return {
        openedAt: undefined,
        closedAt: toRawDirection(sort._0),
        turnover: undefined,
        totalAmountIncludingTaxes: undefined
      };
    case "TotalAmount":
      return {
        openedAt: undefined,
        closedAt: undefined,
        turnover: undefined,
        totalAmountIncludingTaxes: toRawDirection(sort._0)
      };
  }
}
function queryVariables(param) {
  let match = param.connectionArguments;
  return {
    search: param.searchQuery,
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last,
    filterBy: queryVariablesFilterBy(param.filters),
    orderBy: [queryVariablesOrderBy(param.sorting)]
  };
}
let tableLoadingOperations = [query];
function useQueryAsyncResultFn(variables) {
  return ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, variables));
}
function CashRegisterReportsListPage(props) {
  let __useQueryAsyncResult = props.useQueryAsyncResult;
  let useQueryAsyncResult = __useQueryAsyncResult !== undefined ? __useQueryAsyncResult : useQueryAsyncResultFn;
  let authScope = Auth.useScope();
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let match = React.useState(() => {});
  let setNotification = match[1];
  let filters_kind = "Daily";
  let filters_statuses = defaultStatuses("Daily");
  let filters_openedByStaffs = [];
  let filters_devices = [];
  let filters = {
    shop: activeShop,
    kind: filters_kind,
    openedAt: undefined,
    closedAt: undefined,
    statuses: filters_statuses,
    amount: undefined,
    openedByStaffs: filters_openedByStaffs,
    devices: filters_devices
  };
  let initialState = ResourceList.initialState(undefined, filters, {
    TAG: "OpenedAt",
    _0: "descending"
  }, undefined, undefined);
  let filtersJsonCodec = jsonCodec(shops);
  let match$1 = ResourceList.use(initialState, filtersJsonCodec, jsonCodec$1, undefined, undefined);
  let dispatch = match$1[1];
  let state = match$1[0];
  let queryAsyncResult = useQueryAsyncResult(queryVariables(state));
  let organisationAccount;
  organisationAccount = authScope.TAG === "Organisation";
  let shopFilter = organisationAccount ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
    variation: "secondary",
    value: state.filters.shop,
    hideLabel: true,
    truncateItemLabel: true,
    onChange: shop => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: shop,
        kind: prev.kind,
        openedAt: prev.openedAt,
        closedAt: prev.closedAt,
        statuses: prev.statuses,
        amount: prev.amount,
        openedByStaffs: prev.openedByStaffs,
        devices: prev.devices
      })
    })
  }) : null;
  let activeFiltersCount = activeCount(state.filters);
  let onRequestResetFilters = activeFiltersCount > 0 ? () => dispatch({
    TAG: "FiltersUpdated",
    _0: prev => {
      let init = initialState.filters;
      return {
        shop: prev.shop,
        kind: prev.kind,
        openedAt: init.openedAt,
        closedAt: init.closedAt,
        statuses: defaultStatuses(prev.kind),
        amount: init.amount,
        openedByStaffs: init.openedByStaffs,
        devices: init.devices
      };
    }
  }) : undefined;
  let shopId = Stdlib_Option.map(state.filters.shop, shop => shop.id);
  let options = availableStatuses(state.filters.kind);
  let len = options.length;
  let filters$1 = Belt_Array.concatMany([[JsxRuntime.jsx(SelectDateRangeFilter.make, {
    value: state.filters.openedAt,
    label: I18n.t("Opening date"),
    size: "compact",
    highlighted: Stdlib_Option.isSome(state.filters.openedAt),
    placeholder: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
    hidePresets: true,
    onChange: openedAt => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        kind: prev.kind,
        openedAt: openedAt,
        closedAt: prev.closedAt,
        statuses: prev.statuses,
        amount: prev.amount,
        openedByStaffs: prev.openedByStaffs,
        devices: prev.devices
      })
    }),
    triggerLabelDisplay: "showDateRange"
  }), JsxRuntime.jsx(SelectDateRangeFilter.make, {
    value: state.filters.closedAt,
    label: I18n.t("Closing date"),
    size: "compact",
    highlighted: Stdlib_Option.isSome(state.filters.closedAt),
    placeholder: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
    hidePresets: true,
    onChange: closedAt => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        kind: prev.kind,
        openedAt: prev.openedAt,
        closedAt: closedAt,
        statuses: prev.statuses,
        amount: prev.amount,
        openedByStaffs: prev.openedByStaffs,
        devices: prev.devices
      })
    }),
    triggerLabelDisplay: "showDateRange"
  }), JsxRuntime.jsx(CanarySeparator.make, {
    size: "medium",
    spacing: "xs"
  })], len !== 1 ? len !== 0 ? [JsxRuntime.jsx(make$2, {
    options: options,
    value: state.filters.statuses,
    onChange: statuses => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        kind: prev.kind,
        openedAt: prev.openedAt,
        closedAt: prev.closedAt,
        statuses: statuses,
        amount: prev.amount,
        openedByStaffs: prev.openedByStaffs,
        devices: prev.devices
      })
    })
  })] : [] : [], [JsxRuntime.jsx(SelectNumberRangeFilter.make, {
    label: I18n.t("Revenue incl. VAT"),
    precision: 2,
    formatValue: value => I18n.currencyFormat(undefined, "EUR", undefined, undefined, value),
    value: state.filters.amount,
    onChange: amount => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        kind: prev.kind,
        openedAt: prev.openedAt,
        closedAt: prev.closedAt,
        statuses: prev.statuses,
        amount: amount,
        openedByStaffs: prev.openedByStaffs,
        devices: prev.devices
      })
    })
  }), JsxRuntime.jsx(StaffSelect.make, {
    label: I18n.t("Seller"),
    size: "compact",
    shopId: shopId,
    value: state.filters.openedByStaffs,
    onChange: openedByStaffs => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        kind: prev.kind,
        openedAt: prev.openedAt,
        closedAt: prev.closedAt,
        statuses: prev.statuses,
        amount: prev.amount,
        openedByStaffs: openedByStaffs,
        devices: prev.devices
      })
    })
  }), JsxRuntime.jsx(DeviceSelect.make, {
    size: "compact",
    shopId: shopId,
    value: state.filters.devices,
    onChange: devices => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        kind: prev.kind,
        openedAt: prev.openedAt,
        closedAt: prev.closedAt,
        statuses: prev.statuses,
        amount: prev.amount,
        openedByStaffs: prev.openedByStaffs,
        devices: devices
      })
    })
  })]]);
  let searchBar = JsxRuntime.jsx(ResourceListPage.ResourceListSearchBar.make, {
    placeholder: I18n.t("Search") + "...",
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let onTableSortChange = sortDescriptor => {
    let sort = fromSortDescriptor(sortDescriptor);
    if (sort.TAG === "Ok") {
      return dispatch({
        TAG: "SortingUpdated",
        _0: sort._0
      });
    }
  };
  let newrecord = {
    ...{
      style: {
        borderBottomColor: "#E7E7EE",
        borderBottomStyle: "solid",
        borderBottomWidth: "1px"
      }
    }
  };
  let tableHeader = JsxRuntime.jsxs(View.make, (newrecord.children = [JsxRuntime.jsx(make, {
    notification: match[0],
    onRequestClose: () => setNotification(param => {})
  }), JsxRuntime.jsx(CategoryTablist.make, {
    items: items(),
    value: toKey(state.filters.kind),
    onChange: key => {
      let kind = CashRegisterReport.Kind.fromString(key);
      let statuses = defaultStatuses(kind);
      dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          kind: kind,
          openedAt: prev.openedAt,
          closedAt: prev.closedAt,
          statuses: statuses,
          amount: prev.amount,
          openedByStaffs: prev.openedByStaffs,
          devices: prev.devices
        })
      });
    }
  })], newrecord));
  let timeAndStaffLabel = (date, staffName) => I18n.template(I18n.t("cash_register_reports_list_page.table.time_and_staff_sublabel"), {
    time: DateHelpers.formateToShortTime(undefined, date),
    staff: staffName
  }, undefined);
  let tableColumns = [{
    key: "name",
    name: I18n.t("Number"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 130
      },
      width: {
        NAME: "fr",
        VAL: 1.2
      },
      sticky: true
    },
    render: param => JsxRuntime.jsx(LabelTableCell.make, {
      label: CashRegisterReport.nameLabel(param.data.name),
      inPrimaryColumn: true
    })
  }, {
    key: "kind",
    name: I18n.t("Kind"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 90
      },
      width: {
        NAME: "fr",
        VAL: 0
      }
    },
    render: param => JsxRuntime.jsx(CashRegisterReport.Kind.Badge.make, {
      value: param.data.kind
    })
  }, {
    key: "status",
    name: I18n.t("Status"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 100
      },
      width: {
        NAME: "fr",
        VAL: 0
      }
    },
    render: param => JsxRuntime.jsx(CashRegisterReport.Status.Badge.make, {
      value: param.data.status
    })
  }, {
    key: "opened-at",
    name: I18n.t("cash_register_reports_list_page.table.opened_column.title"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 140
      }
    },
    allowsSorting: true,
    render: param => {
      let match = param.data;
      let openedAt = match.openedAt;
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: DateHelpers.formateToShortDate(openedAt),
        sublabel: timeAndStaffLabel(openedAt, match.openedByStaffName)
      });
    }
  }, {
    key: "closed-at",
    name: I18n.t("cash_register_reports_list_page.table.closed_column.title"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 140
      }
    },
    allowsSorting: true,
    render: param => {
      let match = param.data;
      let closedAt = match.closedAt;
      if (closedAt === undefined) {
        return JsxRuntime.jsx(Placeholder.NC.make, {});
      }
      let closedByStaffName = match.closedByStaffName;
      let match$1 = CashRegisterReport.closingLabels(match.kind, match.openedAt, closedAt);
      let sublabel = closedByStaffName !== undefined ? timeAndStaffLabel(closedAt, closedByStaffName) : match$1[1];
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: match$1[0],
        labelBold: true,
        sublabel: sublabel
      });
    }
  }, {
    key: "total-amount",
    name: I18n.t("Revenue incl. VAT"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 95
      },
      width: {
        NAME: "fr",
        VAL: 1
      }
    },
    allowsSorting: true,
    render: param => {
      let match = param.data;
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: I18n.currencyFormat(undefined, "EUR", undefined, undefined, match.totalAmountIncludingTaxes),
        labelBold: true,
        sublabel: I18n.currencyFormat(undefined, "EUR", undefined, undefined, match.totalAmountExcludingTaxes) + " " + I18n.t("VAT excl.")
      });
    }
  }, {
    key: "sales-receipt-name-range",
    name: I18n.t("Sales receipts range"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 150
      }
    },
    render: param => {
      let salesReceiptNameRange = param.data.salesReceiptNameRange;
      if (salesReceiptNameRange !== undefined) {
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: salesReceiptNameRange
        });
      } else {
        return JsxRuntime.jsx(Placeholder.NC.make, {});
      }
    }
  }, {
    key: "source",
    name: I18n.t("Source"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 150
      },
      width: {
        NAME: "fr",
        VAL: 0
      }
    },
    render: param => {
      let match = param.data;
      let deviceLabel = match.deviceLabel;
      let sublabel = shops.length > 1 ? StringHelpers.truncateWithMiddleEllipsis(match.shopName, 23) : undefined;
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: deviceLabel,
        sublabel: sublabel,
        tooltip: JsxRuntime.jsx(Tooltip.Span.make, {
          text: deviceLabel
        })
      });
    }
  }, {
    key: "actions",
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 48
      },
      width: {
        NAME: "px",
        VAL: 48
      },
      alignX: "flexEnd",
      sticky: true
    },
    render: param => {
      let match = param.data;
      if (match.closedAt !== undefined) {
        return JsxRuntime.jsx(make$3, {
          id: match.id,
          name: match.name,
          kind: match.kind,
          onRequestNotification: textStatus => setNotification(param => textStatus)
        });
      } else {
        return null;
      }
    }
  }];
  let tableData = AsyncResult.mapError(AsyncResult.mapOk(queryAsyncResult, tableRowsFromQueryResult), param => {});
  let paginationTotalCount;
  if (typeof queryAsyncResult !== "object") {
    paginationTotalCount = 0;
  } else if (queryAsyncResult.TAG === "Reloading") {
    let match$2 = queryAsyncResult._0;
    paginationTotalCount = match$2.TAG === "Ok" ? match$2._0.cashRegisterReports.totalCount : 0;
  } else {
    let match$3 = queryAsyncResult._0;
    paginationTotalCount = match$3.TAG === "Ok" ? match$3._0.cashRegisterReports.totalCount : 0;
  }
  let paginationTotalPages = ResourceList.totalPages(paginationTotalCount, ResourceList.defaultEdgesPerPage);
  let paginationLoading = AsyncResult.isReloading(queryAsyncResult);
  let paginationLastDirection = state.currentPage > state.previousPage ? "Forward" : "Backward";
  let onRequestPaginate = React.useCallback(action => {
    let startCursor;
    let endCursor;
    let totalCount;
    if (typeof queryAsyncResult !== "object") {
      return;
    }
    if (queryAsyncResult.TAG === "Reloading") {
      let match = queryAsyncResult._0;
      if (match.TAG !== "Ok") {
        return;
      }
      let match$1 = match._0.cashRegisterReports;
      let match$2 = match$1.pageInfo;
      startCursor = match$2.startCursor;
      endCursor = match$2.endCursor;
      totalCount = match$1.totalCount;
    } else {
      let match$3 = queryAsyncResult._0;
      if (match$3.TAG !== "Ok") {
        return;
      }
      let match$4 = match$3._0.cashRegisterReports;
      let match$5 = match$4.pageInfo;
      startCursor = match$5.startCursor;
      endCursor = match$5.endCursor;
      totalCount = match$4.totalCount;
    }
    let totalPages = ResourceList.totalPages(totalCount, ResourceList.defaultEdgesPerPage);
    let nextPage = ResourceList.nextPage(state, action, totalPages);
    let cursors = [startCursor, endCursor];
    if (nextPage !== undefined) {
      return dispatch({
        TAG: "Navigated",
        nextPage: nextPage,
        totalCount: totalCount,
        cursors: cursors
      });
    }
  }, [state.currentPage, queryAsyncResult]);
  let tableLoadingInteraction = ResourceList.useLoadingInteraction(state, undefined);
  return JsxRuntime.jsx(ResourceListPage.make, {
    title: I18n.t("cash_register_reports_list_page.title"),
    shopFilter: shopFilter,
    filters: filters$1,
    activeFiltersCount: activeFiltersCount,
    searchBar: searchBar,
    tableHeader: tableHeader,
    tableData: tableData,
    tableColumns: tableColumns,
    tableKeyExtractor: keyExtractor,
    tableEmptyState: JsxRuntime.jsx(Placeholder.make, {
      status: "NoDataAvailable"
    }),
    paginationCurrentPage: state.currentPage,
    paginationTotalCount: paginationTotalCount,
    paginationTotalPages: paginationTotalPages,
    paginationLoading: paginationLoading,
    paginationLastDirection: paginationLastDirection,
    tableSortDescriptor: toSortDescriptor(state.sorting),
    tableLoadingOperations: tableLoadingOperations,
    tableLoadingInteraction: tableLoadingInteraction,
    onTableSortChange: onTableSortChange,
    onRequestPaginate: onRequestPaginate,
    onRequestResetFilters: onRequestResetFilters
  });
}
let make$4 = CashRegisterReportsListPage;
export { CashRegisterReportsListNotificationBanner, CashRegisterReportsListExportRequest, CashRegisterReportsListQuery, CashRegisterReportsListTableRow, tableRowsFromQueryResult, CashRegisterReportsListFilters, CashRegisterReportsListStatusSelect, CashRegisterReportsListKindTabs, CashRegisterReportsListTableRowActions, CashRegisterReportsListSorting, queryVariablesDateFilter, queryVariablesInFilter, queryVariablesFilterBy, queryVariablesOrderBy, queryVariables, tableLoadingOperations, useQueryAsyncResultFn, make$4 as make };
/* make Not a pure module */